import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, X } from "lucide-react";

export default function MagicModal({ open, onClose, title, subtitle, children, testId }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid={testId || "magic-modal"}
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div
            className="absolute inset-0 backdrop-blur-md"
            style={{ backgroundColor: "rgba(44, 42, 40, 0.45)" }}
            onClick={onClose}
          />
          <motion.div
            initial={{ scale: 0.92, y: 20, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="relative z-10 max-w-lg w-full rounded-3xl p-8 md:p-12 text-center border shadow-2xl"
            style={{ backgroundColor: "#EFEFE6", borderColor: "rgba(184,153,104,0.3)" }}
          >
            {onClose && (
              <button
                data-testid="modal-close-btn"
                onClick={onClose}
                className="absolute top-5 right-5 p-2 rounded-full transition"
                style={{ color: "#75716C" }}
              >
                <X size={18} />
              </button>
            )}
            <Sparkles size={32} strokeWidth={1.3} className="mx-auto mb-5" style={{ color: "#B89968" }} />
            <h2 className="font-serif-display text-3xl md:text-4xl tracking-tight italic" style={{ color: "#2C2A28" }}>
              {title}
            </h2>
            {subtitle && <p className="mt-3 text-sm md:text-base" style={{ color: "#4A4744" }}>{subtitle}</p>}
            {children && <div className="mt-7">{children}</div>}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
